import { useState } from "react";

export default function BannerVentures() {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <div className="w-full relative">
            <div
                className="w-full h-[580px] md:h-[480px] bg-cover bg-center flex items-center justify-center text-center px-12"
                style={{ backgroundImage: "url(/assets/cover-ventures.png)" }}
            >
                <div className="text-white">
                    <h2 className="text-6xl md:text-[98px] font-titillium-web-bold -mt-2 mb-8">
                        VENTURES
                    </h2>
                    <p className="max-w-[800px] text-2xl md:text-[37px] mb-12 font-inter-bold leading-[1.2]">
                        Estratégia, estrutura e execução para{" "}
                        <span className="font-inter-light">
                            transformar boas ideias em grandes negócios
                        </span>
                        .
                    </p>
                    <a
                        href="/ventures"
                        className="inline-block bg-white text-[#422776] font-inter-bold py-2 px-10 rounded-full hover:scale-105 hover:cursor-pointer duration-100"
                        style={{
                            transform: isHovered ? "scale(1.05)" : "scale(1)",
                        }}
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                    >
                        Saber mais
                    </a>
                </div>
            </div>
        </div>
    );
}
